import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Roles from '../../../common/Roles';

const states: Ng1StateDeclaration[] = [
    {
        name: 'applications.management',
        url: '/management',
        component: 'wtApplicationsManagement',
        data: {
            visible: false,
            sortingOrder: 100,
            icon: 'fa-file-archive-o',
            displayName: 'Applications management',
            editRoles: [Roles.administrator, Roles.engineer],
            editButtonVisibility: () => false
        }
    }
];

export default states;